import type { DeliveryCampaignTargetRow } from '../api';

type StartConditionTarget = Pick<
  DeliveryCampaignTargetRow,
  'targetKey' | 'label' | 'dependencyKeys' | 'rolloutStrategy' | 'metadata'
>;

/** Show the prerequisites recorded for a release target without implying a fixed sequence. */
export function describeCampaignStartCondition(
  target: StartConditionTarget,
  targets: StartConditionTarget[]
): string {
  if (
    target.rolloutStrategy === 'manual' &&
    target.metadata?.['operatorApproval']
  ) {
    return target.dependencyKeys.length
      ? 'Approved · prerequisites complete'
      : 'Approved · ready to start';
  }
  if (!target.dependencyKeys.length) {
    return target.rolloutStrategy === 'manual'
      ? 'Approval required'
      : 'Can start in parallel';
  }

  const byKey = new Map(
    targets.map((candidate) => [candidate.targetKey, candidate])
  );
  const prerequisites = target.dependencyKeys.map((key) => byKey.get(key));
  const known = prerequisites.flatMap((candidate) =>
    candidate ? [candidate.label] : []
  );
  const missingCount = prerequisites.length - known.length;
  const labels = known.join(', ');

  const timing =
    target.rolloutStrategy === 'manual' ? 'Approval required after' : 'After';
  if (missingCount && labels)
    return `${timing} ${labels} and ${missingCount} unavailable prerequisite${missingCount === 1 ? '' : 's'}`;
  if (missingCount)
    return `${timing} ${missingCount} unavailable prerequisite${missingCount === 1 ? '' : 's'}`;
  return `${timing} ${labels}`;
}
